import { COLLECTION_SUMMARY_REQUEST, COLLECTION_SUMMARY_SUCCESS,COLLECTION_DETAILS_SUCCESS,COLLECTION_DETAILS_REQUEST, SERVICE_REVENUE_SUCCESS,SERVICE_REVENUE_REQUEST, BILL_SUMMARY_SUCCESS, BILL_SUMMARY_REQUEST, BILL_REVENUE_REQUEST, BILL_REVENUE_SUCCESS, CATEGORY_LIST_SUCCESS, CATEGORY_LIST_REQUEST, DOCTOE_REPORT_SUCCESS, DOCTOE_REPORT_REQUEST } from "../../shared/constants";
const initialState = {
  loading: false,
  data: null
};

export default function collectionSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case COLLECTION_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      };

    case COLLECTION_SUMMARY_SUCCESS:
      return {
        loading: false,
        data: action.payload
      };

    case COLLECTION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: true
      };

    case COLLECTION_DETAILS_REQUEST:
      return {
        loading: false,
        data: action.payload
      };

    case SERVICE_REVENUE_REQUEST:
      return {
        loading: false,
        data: action.payload
      };
    
    case SERVICE_REVENUE_SUCCESS:
      return {
        ...state,
        loading: true
      };
      
    case BILL_SUMMARY_REQUEST:
      return {
        loading: false,
        data: action.payload
      };
    
    case BILL_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: true
      };
      
    case BILL_REVENUE_REQUEST:
      return {
        loading: false,
        data: action.payload
      };
    
    case BILL_REVENUE_SUCCESS:
      return {
        ...state,
        loading: true
      };

    case DOCTOE_REPORT_REQUEST:
      return {
        loading: false,
        data: action.payload
      };
    
    case DOCTOE_REPORT_SUCCESS:
      return {
        ...state,
        loading: true
      };
      
    case CATEGORY_LIST_REQUEST:
      return {
        loading: false,
        data: action.payload
      };
    
    case CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        loading: true
      };

    default:
      return state;
  }
}
